module.exports = __webpack_public_path__ + "img/orders_title.95fde1d6.svg";